export class CreateNewSystemConnectionRequest {
	connectionName: string;
	connectionType: string;
	serverType: string;
	serverAddress: string;
	timeout: number;
	username: string;
	password: string;
	connectionString: string;
	database: string;
	port: number | null;
	databaseTimezone: string;
	sampleDurationSeconds: number;
	queryLagMinutes: number;
	queryGroupSize: number;
	caseSensitiveSensorId: boolean;
	simulationSubtractionDays: number;
	dateTimeFormat: string;
	quoteFormat: string;
	resourcePath: string;
	opcuaUrl: string;
	timestampConversion: string;
	tagFormat: string;
	securityMode: string;
	securityPolicy: string;
	endpointMustExist?: boolean;
	sessionName: string;
	queryPrefix: string;

	constructor(
		connectionName: string,
		connectionType: string,
		serverType: string,
		serverAddress: string,
		timeout: number,
		username: string,
		password: string,
		connectionString: string,
		database: string,
		port: number,
		databaseTimezone: string,
		sampleDurationSeconds: number,
		queryLagMinutes: number,
		queryGroupSize: number,
		caseSensitiveSensorId: boolean | string,
		simulationSubtractionDays: number,
		dateTimeFormat: string,
		quoteFormat: string,
		resourcePath: string,
		opcuaUrl: string,
		timestampConversion: string,
		tagFormat: string,
		securityMode: string,
		securityPolicy: string,
		endpointMustExist: string | undefined,
		sessionName: string,
		queryPrefix: string,
	) {
		this.connectionName = connectionName;
		this.connectionType = connectionType;
		this.serverType = serverType;
		this.serverAddress = serverAddress;
		this.timeout = timeout;
		this.username = username;
		this.password = password;
		this.connectionString = connectionString;
		this.database = database;
		this.port = port;
		this.databaseTimezone = databaseTimezone;
		this.sampleDurationSeconds = sampleDurationSeconds;
		this.queryLagMinutes = queryLagMinutes;
		this.queryGroupSize = queryGroupSize;
		this.caseSensitiveSensorId =
			`${caseSensitiveSensorId}`?.toLowerCase() === 'true';
		this.simulationSubtractionDays = simulationSubtractionDays;
		this.dateTimeFormat = dateTimeFormat;
		this.quoteFormat = quoteFormat;
		this.resourcePath = resourcePath;
		this.opcuaUrl = opcuaUrl;
		this.timestampConversion = timestampConversion;
		this.tagFormat = tagFormat;
		this.securityMode = securityMode;
		this.securityPolicy = securityPolicy;
		if (endpointMustExist !== undefined) {
			this.endpointMustExist =
				endpointMustExist?.toLowerCase() === 'true';
		}
		this.sessionName = sessionName;
		this.queryPrefix = queryPrefix;
		// something
	}
}

export type QuoteType = 'DOUBLE_QUOTE' | 'BACK_TICK';
export type DateType = 'ANSI' | 'ORACLE';
export type ServerType =
	| 'MSSQL'
	| 'ORACLE'
	| 'MYSQL'
	| 'PI'
	| 'PIProvider'
	| 'ClearSCADA';
export type ServerTypeOledb =
	| 'SQLOLEDB'
	| 'MSOLEDBSQL'
	| 'ihOLEDB.iHistorian.1'
	| 'PIOLEDB.1'
	| 'SQLNCLI11';
export type TimestampConversionType =
	| 'IMPLICIT'
	| 'TIMESTAMP_prefix'
	| 'TS_function';
export type TagFieldFormatType = 'STRING' | 'NUMBER';

export type CreateNewSystemConnectionRequestForm = Partial<
	Record<keyof CreateNewSystemConnectionRequest, string>
>;
